import { IcommonUser } from './icommonuserinterFace';
export class User extends IcommonUser {
  firstName: string = '';
  middleName: string = '';
  lastName: string = '';
  additionalLastName: string = '';
  email: string = '';
  mobile: string = '';
  termsUse: boolean = false;
  OTP: string = '';
  RegistrationCode: string = '';
  mobilePrefix: number = 0;
  state: string = '';
  stateName: string = '';
  city: string = '';
  country: string = 'US';
  countryName: string = 'United States';
  methodName: string = '';
  address: string = '';
  occupation: string = '';
  employess: string = '';
  dobflag: boolean = false;
  tranflag: boolean = false;
  password: string = '';
  loyaltyCardNumber: string = '';
  zipcode: string = '';
  UserProfileImage: string;
  UserProfileImageBase64: string;
  UserImage: string = '';
  dob: string = '';
  userimageurl: string = '';
  LastOrderNumber: string = '';
  IsBeingLinked;
  referCode = '';
  maxTransferAmountLimit = '0';
  MarketingBalance = 0;
  taxID = '';
  UserVerifiedBy = '';
  IsEmailNew: boolean = false;
  IsPhoneNew: boolean = false;
  constructor() {
    super();
  }
}



// WEBPACK FOOTER //
// ./src/app/models/user/user.ts